// extracted by mini-css-extract-plugin
export default {"settings":"publication-service_settings__21K_I","label":"publication-service_label__3noVE"};